export default __webpack_public_path__ + "static/media/5.129b8f28.jpg";